import type { ReactElement } from 'react';

/**
 * 사용자 앱이 `/admin` 아래 주소를 받았을 때의 화면.
 *
 * 운영에서는 nginx 가 `/admin/**` 을 어드민 앱으로 보내 여기까지 오지 않는다. 로컬처럼 두 앱이
 * 따로 뜨는 곳에서 사용자 앱이 받으면 404 가 떴다 — 어느 앱이 받든 방문자에게는
 * 「운영자 페이지」 한 가지로 보이게, 어드민의 차단 화면(AccessGate)과 문구·모양을 맞춘다.
 * 사이트 틀(머리글·바닥글) 없이 그리는 것도 그 때문이다 (router.tsx 에서 RootLayout 밖에 둔다).
 *
 * 역할을 보지 않는다 — 사용자 앱의 세션에는 역할이 없고, 운영자라면 어드민 앱에서 이미 열렸다.
 */
export function AdminOnlyPage(): ReactElement {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-3 px-6 text-center">
      <h1 className="text-[1.0625rem] font-semibold tracking-[-0.028em]">
        운영자 권한이 필요한 페이지입니다
      </h1>
      <p className="text-[14px] leading-[1.9] text-muted-foreground">
        운영자 계정으로 로그인해 주세요.
      </p>
      <a
        href="/login"
        className="mt-2 rounded-md border border-border px-4 py-2 text-[13px] hover:bg-muted"
      >
        로그인하러 가기
      </a>
    </main>
  );
}
